document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('[data-mega-slider]');

  sliders.forEach(slider => {
    const prevBtn = slider.querySelector('.parabaya-mega__slider-arrow--prev');
    const nextBtn = slider.querySelector('.parabaya-mega__slider-arrow--next');
    const track = slider.querySelector('.parabaya-mega__slider-track-inner');
    const slides = slider.querySelectorAll('.parabaya-mega__slide');

    if (!track || slides.length === 0) return;

    let currentIndex = 0;
    const maxSlides = slides.length;

    function updateSliderPosition() {
      const offset = currentIndex * 100; // 100% par slide
      track.style.transform = `translateX(-${offset}%)`;
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex === maxSlides - 1;
    }

    prevBtn.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateSliderPosition();
      }
    });

    nextBtn.addEventListener('click', () => {
      if (currentIndex < maxSlides - 1) {
        currentIndex++;
        updateSliderPosition();
      }
    });

    updateSliderPosition();
  });
});